import axios from 'axios';
import { TOKEN_EXPIRE_SETTINGS } from '@src/constants';

const getJwtEndPoint = `${process.env.REACT_APP_IRPM_API_URL}/get-jwt/`;
const autoSuggestUserEndPoint = `${process.env.REACT_APP_IRPM_API_URL}/auto-suggest/`;
const getUserByEmployeeIdsEndPoint = `${process.env.REACT_APP_IRPM_API_URL}/get-user-by-employeeids/`;

const getCurrentUser = () => {
  const rawCurrentUser = localStorage.getItem('currentUser');
  try {
    return rawCurrentUser ? JSON.parse(rawCurrentUser) : null;
  } catch {
    return null;
  }
};

const isLoggedIn = () => {
  const currentUser = getCurrentUser();
  return currentUser && !isExpired(currentUser);
};

const fetchCurrentUser = async (jti, nounce) => {
  const res = await axios.get(getJwtEndPoint + JSON.stringify(
    {
      jti,
      nounce,
      ...TOKEN_EXPIRE_SETTINGS,
    },
  ));
  const result = res.data;
  if (result.d) {
    const { jwt } = result.d;
    extractJwtToken(jwt);
  } else {
    console.error(result.x);
  }
};

const autoSuggestUser = async (value) => {
  if (isLoggedIn()) {
    const { access_token: sjwt } = getCurrentUser();
    const headers = { Authorization: `Bearer ${sjwt}` };
    const res = await axios.post(autoSuggestUserEndPoint, { searchName: value }, { headers });
    const result = res.data;
    if (result.d) {
      const { user } = result.d;
      return user;
    }
    console.error(result.x);
  }
  return [];
};

const getUserByEmployeeIds = async (ids) => {
  if (isLoggedIn() && Array.isArray(ids) && ids.length > 0) {
    const { access_token: sjwt } = getCurrentUser();
    const headers = { Authorization: `Bearer ${sjwt}` };
    const params = {
      employeeID: ids.join(','),
    };
    const res = await axios.get(
      `${getUserByEmployeeIdsEndPoint}${JSON.stringify(params)}`,
      { headers },
    );
    const result = res.data;
    if (result.d) {
      const { user } = result.d;
      return user;
    }
    console.error(result.x);
  }
  return [];
};
const extractJwtToken = (jwt) => {
  const parts = jwt.split('.');
  let base64 = parts[1];
  if (!base64) {
    return;
  }
  base64 = base64.replace(/-/g, '+').replace(/_/g, '/');
  const bodyStr = atob(base64);
  let body = null;
  try {
    body = JSON.parse(bodyStr);
  } catch (e) {
    body = {};
  }
  const { exp, usr: user } = body;
  user.access_token = jwt;
  user.expire = exp;
  if (Array.isArray(user.name)) {
    user.name = user.name.join(' ');
  }
  save(user);
};

const isExpired = (currentUser) => {
  const user = currentUser || getCurrentUser();
  const exp = user && user.expire;
  if (!exp) {
    return true;
  }
  const now = Date.now();
  return now >= exp * 1000;
};

const logout = () => {
  localStorage.removeItem('currentUser');
};

const save = (user) => {
  localStorage.setItem('currentUser', JSON.stringify(user));
};

export default {
  fetchCurrentUser,
  extractJwtToken,
  autoSuggestUser,
  getUserByEmployeeIds,
  logout,
  isLoggedIn,
  getCurrentUser,
};
